import * as Types from '@trello/graphql/generated';

import DocumentNode from '@trello/graphql/src/documentNode';
import * as Apollo from '@apollo/client';
const defaultOptions =  {"context":{"operationName":"OrgIdFromOrg"}}
export type OrgIdFromOrgQueryVariables = Types.Exact<{
  name: Types.Scalars['ID'];
}>;


export type OrgIdFromOrgQuery = (
  { __typename: 'Query' }
  & { organization?: Types.Maybe<(
    { __typename: 'Organization' }
    & Pick<Types.Organization, 'id'>
  )> }
);


export const OrgIdFromOrgDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"OrgIdFromOrg"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organization"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useOrgIdFromOrgQuery__
 *
 * To run a query within a React component, call `useOrgIdFromOrgQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrgIdFromOrgQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrgIdFromOrgQuery({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useOrgIdFromOrgQuery(baseOptions: Apollo.QueryHookOptions<OrgIdFromOrgQuery, OrgIdFromOrgQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrgIdFromOrgQuery, OrgIdFromOrgQueryVariables>(OrgIdFromOrgDocument, options);
      }
export function useOrgIdFromOrgLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrgIdFromOrgQuery, OrgIdFromOrgQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrgIdFromOrgQuery, OrgIdFromOrgQueryVariables>(OrgIdFromOrgDocument, options);
        }
export type OrgIdFromOrgQueryHookResult = ReturnType<typeof useOrgIdFromOrgQuery>;
export type OrgIdFromOrgLazyQueryHookResult = ReturnType<typeof useOrgIdFromOrgLazyQuery>;
export type OrgIdFromOrgQueryResult = Apollo.QueryResult<OrgIdFromOrgQuery, OrgIdFromOrgQueryVariables>;